export default __webpack_public_path__ + "static/media/4497.e0269059.png";